import { render, staticRenderFns } from "./BaseClearInputButton.vue?vue&type=template&id=8c1835f8"
import script from "./BaseClearInputButton.vue?vue&type=script&lang=js"
export * from "./BaseClearInputButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports